// ======================================================================
// File Name       : ServiceLoginContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { doLoginServiceCheck, serviceSearch } from '../actions/ServiceLoginAction';
import MessageSearch from '../components/MessageSearch';
import ServiceLoginList from '../components/ServiceLoginList';
import ServiceLoginSearch from '../components/ServiceLoginSearch';
import ServiceLoginType from '../components/ServiceLoginType';
import { SHOW_MESSAGE } from '../constants/actionTypes/message';
import { RETURN_MAX_NUM } from '../constants/index';
import { W_SERVICE_NOT_FOUND } from '../constants/MessageTemplate';
import { removeAllScriptExcludeBundleJS } from '../utils';
import { SUPER_USER } from '../constants/index';
import { TOKEN } from '../constants/LocalStorageConstants';
import { EXTERNAL_REQUEST_PASSCD} from '../constants';

class ServiceLoginContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      serviceName: '',
      serviceType: 0,
      serviceCd: null,
      serviceSortType: null,
      ascendingDescendingSort: 0,
      startPosition: 0,
      isAllowShowSearchMessage: false,
      isInit: true,
    };

    this.handleServiceLogin = this.handleServiceLogin.bind(this);
    this.handleChangeServiceType = this.handleChangeServiceType.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.handleSelectService = this.handleSelectService.bind(this);
    this.handleSearchBtn = this.handleSearchBtn.bind(this);
    this.handleChangeTextInput = this.handleChangeTextInput.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
  }

  componentDidMount() {
    this.searchServiceList();
    const { authedUser } = this.props;
    const token = authedUser ? authedUser.token : localStorage.getItem(TOKEN);
    window.saveToken(token);
    window.sendToken(token);
  }

  componentWillReceiveProps(nextProps) {
    const { history, auth } = nextProps;
    // Login to service.
    if (!auth.institutionId) {
      if (auth.serviceCd && auth.serviceName) {
        history.push('/top');
      }
    } else {
      const isLoginedService = this.state.serviceCd === auth.serviceCd;
      if (isLoginedService && auth.serviceName) {
        // #7232 START
        // #7287 START
        removeAllScriptExcludeBundleJS();
        // #7287 END
        // #7232 END
        history.push('/top');
      }
    }
  }

  /**
   * Search
   */
  searchServiceList() {
    const auth = this.props.auth;
    const param = {
      selectTargetData: 0,
      searchInfo: {
        serviceName: this.state.serviceName,
        serviceTypeList: [this.state.serviceType],
        enterpriseCd: auth.enterpriseCd,
        serviceSortType: this.state.serviceSortType,
        ascendingDescendingSort: this.state.ascendingDescendingSort,
        startPosition: this.state.startPosition,
        returnMaxNum: RETURN_MAX_NUM,
      },
    };

    this.props.dispatch(serviceSearch(param)).then(() => {
      if (!this.state.isInit) {
        this.setState({ isAllowShowSearchMessage: true });
      }
    });
  }

  /**
   * Callback when radio button change
   * @param {*} type
   */
  handleChangeServiceType(event) {
    const { name, value } = event.target;
    this.setState({ [name]: Number.parseInt(value, 10),
      serviceCd: null,
      startPosition: 0,
      isAllowShowSearchMessage: false }, () => {
      this.searchServiceList(true);
    });
  }

  /**
   * Callback when text input change
   * @param {*} event
   */
  handleChangeTextInput(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  /**
   * Callback when button search clicked
   */
  handleSearchBtn() {
    this.setState({
      ...this.state,
      serviceCd: null,
      startPosition: 0,
      serviceSortType: null,
      isAllowShowSearchMessage: false,
      isInit: false,
    }, () => {
      this.searchServiceList();
    });
  }

  /**
   * Handle when select service in service list
   * @param {*} serviceCd
   */
  handleSelectService(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  /**
   * Do login service
   */
  handleServiceLogin() {
    const { serviceInfo } = this.props;
    const serviceCd = this.state.serviceCd;
    if (serviceCd === null) {
      this.props.dispatch({
        type: SHOW_MESSAGE,
        message: W_SERVICE_NOT_FOUND,
      });
      return;
    }
    const param = {
      serviceCd,
    };

    let selectedService = null;
    try {
      if (serviceInfo && serviceInfo.serviceList) {
        selectedService = serviceInfo.serviceList.filter((service) => service.serviceCd === serviceCd)[0];
      }
    } catch (error) {
      selectedService = null;
    }

    // Step10.0.0 START
    const certificateData = {
      serviceCd,
      requestPasscd: EXTERNAL_REQUEST_PASSCD,
    };
    this.props.dispatch(doLoginServiceCheck(param, selectedService, certificateData));
    // Step10.0.0 END
  }

  /**
   * handle sort
   * @param {*} sort
   */
  handleSortState(sort) {
    this.setState({
      ...this.state,
      serviceSortType: sort.sortBy,
      ascendingDescendingSort: sort.sortState,
    }, () => {
      this.searchServiceList();
    });
  }

  /**
   * handle page change
   * @param {*} page
   */
  handlePaginationChange(startPosition) {
    this.setState({
      ...this.state,
      serviceCd: null,
      startPosition,
    }, () => {
      this.searchServiceList();
    });
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  render() {
    const { auth } = this.props;
    const { enterpriseName, isShowMsgAfterTrialExpired, userInfo: { displayUserType } } = auth;
    const recordNum = this.props.serviceInfo ? this.props.serviceInfo.recordNum : 0;
    const serviceList = this.props.serviceInfo ? this.props.serviceInfo.serviceList : [];

    return (
      <Form
        className="form-horizontal" style={{ display: 'flow-root' }}
        onSubmit={(e) => { e.preventDefault(); this.handleSearchBtn(); }}>
        <MessageSearch
          recordNum={recordNum}
          resultList={serviceList}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <ServiceLoginType
          onHandleChangeServiceType={this.handleChangeServiceType}
          checked={this.state.serviceType}
        />
        <ServiceLoginSearch
          onHandleChangeTextInput={this.handleChangeTextInput}
          onHandleSearchBtn={this.handleSearchBtn}
        />
        {/* sprint_20230522 START */}
        {isShowMsgAfterTrialExpired && [SUPER_USER].indexOf(displayUserType) > -1 && (
          <Col sm={12} className="margin-top-20 padding-left-right-clear textColorRed bold msgAfterTrialExpired">
            <p className="padding-left-45 margin-top-10">
              トライアル期間が終了しています。
            </p>
            <p className="padding-left-45 margin-top-10 margin-bottom-10">
              ご利用を継続される場合は、サービスを選択をして、ユーザー数をご確認の上、契約の手続きにお進みください。
            </p>
          </Col>
        )}
        {/* sprint_20230522 END */}
        <ServiceLoginList
          serviceInfo={this.props.serviceInfo}
          onHandleSelectService={this.handleSelectService}
          onHandleSortState={this.handleSortState}
          onHandlePaginationChange={this.handlePaginationChange}
          startPosition={this.state.startPosition}
          enterpriseName={enterpriseName}
          serviceSearchInfo={this.state}
        />
        <Form.Group className="text-center">
          <Col sm={12}>
            <Button
              variant="primary"
              className="btn-96 margin-top-30"
              onClick={this.handleServiceLogin}
              disabled={!this.state.serviceCd}
            >
              OK
            </Button>
          </Col>
        </Form.Group>
      </Form>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  serviceInfo: state.serviceLogin.serviceInfo,
  serviceLoginInfo: state.serviceLogin.serviceLoginInfo,
  auth: state.authed.authedUser,
});
export default connect(mapStateToProps)(ServiceLoginContainer);
